// extracted by mini-css-extract-plugin
export var chevron = "_jo-2";
export var dropdownItems = "_jo-0";
export var item = "_jo-1";